<template >
  <div >
    <slot name="content"  ></slot>
  </div>
</template>

<script>

export default {
  beforeCreate() {
  }
};
</script>

<style scoped>

</style>